<template>
  <HelpRegistriesReturned
    :header-additional-text="$t('help_registries.returned.returned').toString()"
    api-read="/api/help_registries/returned/index_pagination_provider"
    :cb_help_status_id="2"
  />
</template>

<script>
import HelpRegistriesReturned from "../../helpRegistries/returned/HelpRegistriesReturned";

export default {
  name: "HelpProviderHelpRegistryReturnedReturned",
  components: {
    'HelpRegistriesReturned': HelpRegistriesReturned
  }
}
</script>

<style scoped>

</style>
